import React from "react";
import { Alert, Col, Row } from "reactstrap";

const SignUpSuccess = () => {
  return (
    <div className={"my-5"}>
      <Row>
        <Col lg={6} className={"mx-auto"}>
          <Alert>
            <h3>Félicitation !</h3>
            <div className={"fw-bold"}>
              Votre compte a été créé avec succès.
            </div>
          </Alert>
        </Col>
      </Row>
      <Row>
        <Col lg={6} className={"mx-auto"}>
          <div className={"fs-5"}>
            Un message vous a été envoyé à l'adresse e-mail que vous avez
            renseigné.
          </div>
          <br />
          <div className={"fs-5"}>
            <div className={"fw-bold"}>Attention ! </div>
            Afin de pouvoir accéder à votre espace personnel, vous devez cliquer
            sur le lien présent dans le mail pour confirmer votre adresse
            e-mail.
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default SignUpSuccess;
